module.exports = __webpack_public_path__ + "img/es.f144d109.svg";